import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import {
  Alert,
  AlertIcon,
  Button,
  Container,
  Divider,
  Heading,
  Link,
  Spinner,
  Text,
} from '@chakra-ui/react';
import { useSectionBgGradient } from '../style/palette';

/**
 * Pagina di conferma della disiscrizione dalla newsletter.
 * Il link nell'email porta qui; la disiscrizione avviene solo col pulsante
 * (gli antivirus delle caselle aprono i link da soli).
 */
const NewsletterUnsubscribe = () => {
  const [searchParams] = useSearchParams();
  const e = searchParams.get('e') || '';
  const s = searchParams.get('s') || '';

  const [state, setState] = useState('checking'); // checking | ready | invalid | sending | done | error
  const [email, setEmail] = useState('');
  const bgGradient = useSectionBgGradient();

  useEffect(() => {
    let active = true;
    if (!e || !s) {
      setState('invalid');
      return undefined;
    }
    axios
      .get('/api/newsletter/unsubscribe/check', { params: { e, s } })
      .then((res) => {
        if (!active) return;
        setEmail(res.data?.email || '');
        setState('ready');
      })
      .catch(() => active && setState('invalid'));
    return () => {
      active = false;
    };
  }, [e, s]);

  const confirm = async () => {
    setState('sending');
    try {
      await axios.post('/api/newsletter/unsubscribe', { e, s });
      setState('done');
    } catch {
      setState('error');
    }
  };

  return (
    <Container
      maxW="lg"
      mt={12}
      mb={12}
      p={8}
      borderRadius="md"
      boxShadow="lg"
      bgGradient={bgGradient}
    >
      <Heading mb={4} fontSize="32px">
        Disiscrizione dalla newsletter
      </Heading>
      <Divider mb={6} />

      {state === 'checking' && <Spinner />}

      {state === 'invalid' && (
        <Alert status="error">
          <AlertIcon />
          Il link non è valido o è incompleto. Puoi gestire la newsletter
          dall’area account oppure scriverci dalla pagina contatti.
        </Alert>
      )}

      {(state === 'ready' || state === 'sending' || state === 'error') && (
        <>
          <Text mb={6}>
            Vuoi smettere di ricevere la newsletter di CIL
            {email ? (
              <>
                {' '}
                all’indirizzo <strong>{email}</strong>
              </>
            ) : null}
            ? Continuerai a ricevere le email legate alle tue prenotazioni e al
            tesseramento.
          </Text>
          {state === 'error' && (
            <Alert status="error" mb={4}>
              <AlertIcon />
              Disiscrizione non riuscita, riprova tra qualche minuto.
            </Alert>
          )}
          <Button
            colorScheme="blue"
            onClick={confirm}
            isLoading={state === 'sending'}
          >
            Conferma disiscrizione
          </Button>
        </>
      )}

      {state === 'done' && (
        <Alert status="success" alignItems="flex-start">
          <AlertIcon />
          <Text>
            Fatto: non riceverai più la newsletter. Se cambi idea puoi
            riattivarla dall’
            <Link as={RouterLink} to="/account" textDecoration="underline">
              area account
            </Link>
            .
          </Text>
        </Alert>
      )}
    </Container>
  );
};

export default NewsletterUnsubscribe;
